module.exports = __webpack_public_path__ + "static/media/externalBarn_2.27855c1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_2.png
// module id = 1306
// module chunks = 3